import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import EndlessTrading from "../components/Home/EndlessTrading/EndlessTrading";
import ArvestIts from "../components/Home/ArvestIts";
import Insights from "../components/Home/Insights";
import JoinBroker from "../components/Home/JoinBroker";
import InMoment from "../components/Home/InMoment";
import TrustPilot from "../components/Home/TrustPilot";
import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import TradeBrain from "../components/Home/TradeBrain";
import AcademyTrade from "../components/Home/AcademyTrade";
import Investing from "../components/Home/Investing";
import NeedHelp from "../components/Home/NeedHelp";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Main/>
            <EndlessTrading/>
            <ArvestIts/>
            <Insights/>
            <JoinBroker/>
            <InMoment/>
            <TrustPilot/>
            <WhyArvest/>
            <ArvestOffers/>
            <TradeBrain/>
            <AcademyTrade/>
            <Investing/>
            <NeedHelp/>
        </div>
    );
}

export default Home;